<template>
  <b-sidebar position="absolute"
              :right="true"
              :fullheight="true"
              :overlay="false"
              :open="activeSidebar === 'group-templates'"
              @close="closeGroupTemplateSidebars">
    <div class="vikingsidebar" v-if="selectedGroup !== null">
      <div class="vikingsidebar__field">
        <div class="header vikingsidebar__field__header">
          <h3>{{ `Gruppe ${selectedGroup.title} - Skabelon` }}</h3>
        </div>
        <div class="show-more-div">
          <b-button @click="showAllPressed" class="show-more-button is-text" >{{showAllLabel}}</b-button>
        </div>
      </div>
      
      <div v-for="(groupTemplate, index) of historicGroupTemplatesDisplayed" 
            :key="index" 
            :class="['vikingsidebar__template', (groupTemplate === formGroupTemplate) && 'vikingsidebar__template--active']">

        <div class="vikingsidebar__template--contents">
          <span>{{ `${groupTemplate.title}` }}</span>
          <span>{{ `${formatDate(groupTemplate.fromDate, "DD-MM-YYYY")} > ${formatDate(groupTemplate.toDate, "DD-MM-YYYY")}` }}</span>
          <span>{{ `H:${groupTemplate.atWorkWeekDays}, L:${groupTemplate.atWorkWeekSaturday}, S:${groupTemplate.atWorkWeekSunday}, HH:${groupTemplate.atWorkHolidayWeekdays}, HW:${groupTemplate.atWorkHolidayWeekend}` }}</span>          
        </div>
        <div class="vikingsidebar__template--controls">
          <span><b-button type="is-text" @click="sidebarBtn_copyGroupTemplate(groupTemplate)">Kopier</b-button></span>
          <span v-if="index === 0 && groupTemplate.fromDate > new Date()"><b-button type="is-text" @click="sidebarBtn_rollbackGroupTemplate(groupTemplate)">Rul tilbage</b-button></span>
        </div>
      </div>
      

      <div class="vikingsidebar__field">
        <div class="vikingsidebar__field__header">
          <h3>{{ `Gruppe ${selectedGroup.title} - Skabelon (KLADDE)` }}</h3>
        </div>
      </div>

      <div v-for="(groupTemplate, index) of groupTemplates.filter(q => q.state === 0)" 
            :key="index + 1000" 
            :class="['vikingsidebar__template', (groupTemplate === formGroupTemplate) && 'vikingsidebar__template--active']">

        <div class="vikingsidebar__template--contents" @click="sidebarBtn_generateGroupTemplate(groupTemplate)" style="cursor: pointer">
          <span v-if="groupTemplate.title">{{ `${groupTemplate.title}` }}</span>
          <span>{{ `${formatDate(groupTemplate.fromDate, "DD-MM-YYYY")} > ${formatDate(groupTemplate.toDate, "DD-MM-YYYY")}` }}</span>
          <span>{{ `H:${groupTemplate.atWorkWeekDays}, L:${groupTemplate.atWorkWeekSaturday}, S:${groupTemplate.atWorkWeekSunday}, HH:${groupTemplate.atWorkHolidayWeekdays}, HW:${groupTemplate.atWorkHolidayWeekend}` }}</span>
        </div>
        <div class="vikingsidebar__template--controls">
          <span><b-button type="is-text" @click="sidebarBtn_editGroupTemplate(groupTemplate)">Rediger</b-button></span>
        </div>
      </div>

      <div class="vikingsidebar__spacer" />

      <div class="vikingsidebar__footer">          
        <div class="vikingsidebar__footer__controls">
          <div class="vikingsidebar__footer__controls--item">
            <b-button @click="sidebarBtn_newDraft" v-if="true" class="is-blue">Ny kladde</b-button>
          </div>
          <div class="vikingsidebar__footer__controls--item">
            <b-button @click="closeGroupTemplateSidebars" class="is-text">Annuller</b-button>
          </div>
          <div class="vikingsidebar__footer__controls--spacer">
          </div>
        </div>
      </div>
    </div>
  </b-sidebar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import moment from 'moment';

export default {
  name: 'group-template-Selection-sidebar',
  props: {
    selectedGroup: {
      type: Object
    },
    groupFilter: {
      type: String
    },
    fromDate: {
      type: String
    },
    toDate: {
      type: String
    }
  },
  computed: {
    ...mapGetters('statisticsStore', ['activeSidebar', 'formGroupTemplate']),
    ...mapGetters("groupTemplateStore", ["groupTemplatesApiState", "groupTemplateApiState", "groupTemplates", "groupTemplate","historicGroupTemplatesDisplayed", "showAll"]),
    showAllLabel(){
      return this.showAll ? 'Vis seneste' : 'Vis alle';
    }
  },
  methods: {
    ...mapActions('statisticsStore', [
      'closeGroupTemplateSidebars',
      'createGroupTemplateFromForm',
      'copyGroupTemplate',
      'rollbackGroupTemplate',
      'generateGroupTemplate',
      'editGroupTemplate',
      'initGroupTemplate'
    ]),
    ...mapActions('groupTemplateStore', ['showAllPressed']),
    formatDate: (date, format) => moment(date).format(format),
    async sidebarBtn_copyGroupTemplate(groupTemplate) {
      await this.copyGroupTemplate({groupTemplate, groupFilter: this.groupFilter});
    },
    async sidebarBtn_rollbackGroupTemplate(groupTemplate) {
      await this.rollbackGroupTemplate({groupTemplate, groupFilter: this.groupFilter});
    },
    async sidebarBtn_generateGroupTemplate(groupTemplate) {
      const selectedDate = await this.generateGroupTemplate({groupTemplate, groupFilter: this.groupFilter});
      this.$emit('selected-date', selectedDate);
    },
    sidebarBtn_editGroupTemplate(groupTemplate) {
      this.editGroupTemplate(groupTemplate);
    },
    async sidebarBtn_newDraft() {
      await this.initGroupTemplate({
        selectedGroup: this.selectedGroup,
        fromDate: this.fromDate,
        toDate: this.toDate,
        groupFilter: this.groupFilter
      });
      await this.createGroupTemplateFromForm({groupFilter: this.groupFilter});
    }
  }
}
</script>

<style lang="scss">
.header{
  width:70%; 
  display:inline-block;
  text-align: left;
}
.show-more-button{
  float: right; 
  margin-top: 40px; 
  margin-bottom: -10px;
  border: 0;
  :active{
    border-width: 0px;
  }
  :focus {
    border-width: 0px;
  }
}
.show-more-div {
  width:30%; 
  display: inline-block;
}
</style>